import * as React from 'react';
import { PriceComponent } from '@msdyn365-commerce/components';
import { IPriceComponentProps } from '@msdyn365-commerce/components/src/price/price.components';
import { getB2BCustomerIdAsync } from '../../../dataActions/DataActionExtension.g';
export default class BmaPrice extends React.Component<any, any> {
    constructor(props: IPriceComponentProps) {
        super(props);
        this.state = { price: { sum: { vk: 0 } } };
    }
    public async componentDidMount() {
        console.log('BmaPrice component did mount');
        if (this.props.snapShotId) {
            await this.loadBmaPrice();
        }
    }
    public async componentDidUpdate(previewProps: any) {
        console.log('BmaPrice component did update');
        if (previewProps.productsCount !== this.props.productsCount && this.props.snapShotId) {
            await this.loadBmaPrice();
        }
    }

    private loadBmaPrice = async () => {
        const b2bCustomer: any = await getB2BCustomerIdAsync(
            { callerContext: this.props.context.actionContext, queryResultSettings: {} },
            this.props.customerInfo.result ? this.props.customerInfo.result.AccountNumber : ''
        );
        if (this.props.context) {
            let bmaPriceEndPoint = this.props.context.app.config.bmaPriceEndPoint.replace('#snapshotId', this.props.snapShotId);
            bmaPriceEndPoint = bmaPriceEndPoint.replace('#jewellerId', b2bCustomer.BMARetailStockist);
            const response = await fetch(`${this.props.context.app.config.bmaBaseUrl}${bmaPriceEndPoint}`);
            const price = await response.json();
            this.setState({ price: price });
        }
    };
    public render(): JSX.Element | null {
        const priceInfo = { ...this.props.data };
        priceInfo.price.AdjustedPrice = this.state.price.sum.vk;
        priceInfo.price.BasePrice = this.state.price.sum.vk;
        priceInfo.price.CustomerContextualPrice = this.state.price.sum.vk;
        priceInfo.price.TradeAgreementPrice = this.state.price.sum.vk;
        return (
            <PriceComponent
                id={this.props.id}
                typeName={this.props.typeName}
                data={priceInfo}
                className='ms-wishlist-items__product-price'
                freePriceText={this.props.freePriceText}
                originalPriceText={this.props.originalPriceText}
                currentPriceText={this.props.currentPriceText}
                context={this.props.context}
            />
        );
    }
}
